export const fetchMails = resp => {
  return {
    type: "FETCH_MAILS",
    payload: resp
  };
};

export const fetchInfiniteMails = resp => {
  return {
    type: "FETCH_INFINITE_MAILS",
    payload: resp
  };
};

export const resetMails = () => {
  return {
    type: "RESET_MAILS"
  };
};

export const fetchGallery = resp => {
  return {
    type: "FETCH_GALLERY",
    payload: resp
  };
};

export const getGalleryItemsByType = mediaType => {
  return {
    type: "GET_GALLERY_ITEMS_BY_TYPE",
    mediaType
  };
};

export const setGalleryItems = medias => ({
  type: `SET_GALLERY_ITEMS`,
  medias
});

export const fetchClientMails = resp => {
  return {
    type: "FETCH_CLIENT_MAILS",
    payload: resp
  };
};

export const fetchInfiniteClientMails = resp => {
  return {
    type: "FETCH_INFINITE_CLIENT_MAILS",
    payload: resp
  };
};

export const resetClientMails = () => {
  return {
    type: "RESET_CLIENT_MAILS"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/ebox.js